'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactFontawesome = require('@fortawesome/react-fontawesome');
var _freeSolidSvgIcons = require('@fortawesome/free-solid-svg-icons');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * The Chip component is used to display labels with the ability to delete them. They are usually used in conjunction with other components like the DropDown.
 */
var ChipBase = function (_React$Component) {
  _inherits(ChipBase, _React$Component);
  function ChipBase(props) {
    _classCallCheck(this, ChipBase);
    var _this = _possibleConstructorReturn(this, (ChipBase.__proto__ || Object.getPrototypeOf(ChipBase)).call(this, props));
    _this.state = {
      showHover: false
    };
    _this.clickEventHandler = _this.clickEventHandler.bind(_this);
    _this.getDisplayValue = _this.getDisplayValue.bind(_this);
    return _this;
  }
  _createClass(ChipBase, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement('div', {
          className: this.props.className,
          'data-component-name': 'Chip',
          'data-component-type': 'SelectedItem'
        }, this.props.children ? this.props.children : _react2['default'].createElement('span', {
          name: 'textContainer',
          title: this.getDisplayValue()
        }, this.getDisplayValue()), this.props.hideClearButton ? null : _react2['default'].createElement('div', {
          name: 'removeIconContainer',
          'data-component-name': 'Chip-Remove',
          onClick: this.clickEventHandler
        }, _react2['default'].createElement(_reactFontawesome.FontAwesomeIcon, {
          icon: _freeSolidSvgIcons.faTimes
        })));
      }
      return render;
    }()

    /**
     * Handler for the click event on the remove cross icon.
     * @param {object} evt The event object
     */
  }, {
    key: 'clickEventHandler',
    value: function () {
      function clickEventHandler(evt) {
        var isDisabled = false;
        if (this.props.disabled === true) {
          isDisabled = true;
        }
        if (isDisabled == false) {
          if (typeof this.props.removeItemEventHandler === 'function') {
            if (this.props.value && this.props.value.length > 0) {
              this.props.removeItemEventHandler(this.props.value, evt);
            } else {
              this.props.removeItemEventHandler(this.props.selectedItem, evt);
            }
          }
        }
        evt.stopPropagation();
      }
      return clickEventHandler;
    }()

    /**
     * Function that returns the display value for the chip.
     */
  }, {
    key: 'getDisplayValue',
    value: function () {
      function getDisplayValue() {
        if (this.props.value && this.props.value.length > 0) {
          return this.props.value;
        } else {
          if (this.props.selectedItem) {
            return this.props.selectedItem[this.props.itemDisplayPropName];
          } else {
            return null;
          }
        }
      }
      return getDisplayValue;
    }()
  }]);
  return ChipBase;
}(_react2['default'].Component);
ChipBase.propTypes = {
  /**
   * Disables the chip component. The remove chip icon does not respond in this case.
   */
  disabled: _propTypes2['default'].bool,
  /**
   * Hide the delete icon on the chip, used when we want to make the chip read-only. Default is false;
   */
  hideClearButton: _propTypes2['default'].bool,
  /**
   * Used in conjunction with the selectedItem prop. This is the key in the selectedItem object, whose value is to be displayed on the chip.
   * used if no children are passed to the chip
   */
  itemDisplayPropName: _propTypes2['default'].string,
  /**
   * The function called when the remove icon on the chip is clicked. The param passed into the function is either the value or the selected item.
   */
  removeItemEventHandler: _propTypes2['default'].func,
  /**
   * The chip can be assigned an object to be displayed. Set the itemDisplayPropName prop to get the string to be displayed.
   */
  selectedItem: _propTypes2['default'].object,
  /**
   * The 'value' is the string displayed on the chip.
   * used if no children are passed to the chip
   */
  value: _propTypes2['default'].string
};
ChipBase.displayName = 'Chip';
exports['default'] = ChipBase;